<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <div class="widget has-shadow">
          <div class="widget-body">
            <router-link class="btn btn-primary mb-4" to="/dashboard/fakeBot">ربات جدید</router-link>
            <button class="btn btn-primary mb-4 ml-2" @click="inserFromExel">بارگذاری اکسل</button>
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>نام کاربری</th>
                    <th>جنسیت</th>
                    <th>سطح</th>
                    <th>آواتارها</th>
                    <th>مهره‌ها</th>
                    <th>آخرین تغییرات</th>
                    <th>عملیات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in users" :key="user._id">
                    <td>{{ user.username }}</td>
                    <td>{{ user.isGirl ? 'دخترونه' : 'پسرونه' }}</td>
                    <td>{{ user.level || 1 }}</td>
                    <td>{{ (user.avatars || []).length }}</td>
                    <td>{{ (user.skins || []).length }}</td>
                    <td>{{ new Date(user.updatedAt).toLocaleString('fa') }}</td>
                    <td>
                      <router-link
                        class="btn btn-gradient-03 mr-3"
                        :to="{ path: '/dashboard/fakeBot', query: { id: user._id } }"
                      >
                        مدیریت
                      </router-link>
                      <button @click="deleteBot(user)" class="btn btn-gradient-01">حذف</button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="row" style="padding:9px 10px">
                <div class="col-sm-12 col-md-6">
                  <div class="dataTables_info" id="sorting-table_info" role="status" aria-live="polite">
                    {{ `صفحه ${page.current} از ${page.total} - تعداد کل: ${page.count} ` }}
                  </div>
                </div>
                <div class="col-sm-12 col-md-6" style="direction:ltr">
                  <div class="dataTables_paginate paging_simple_numbers" id="sorting-table_paginate">
                    <ul class="pagination">
                      <li class="paginate_button page-item previous" id="sorting-table_previous">
                        <a
                          aria-controls="sorting-table"
                          data-dt-idx="0"
                          tabindex="0"
                          class="page-link"
                          @click="getBots({ page: page.pre })"
                          >قبلی</a
                        >
                      </li>
                      <li class="paginate_button page-item">
                        <a aria-controls="sorting-table" data-dt-idx="1" tabindex="0" class="page-link">{{
                          page.current
                        }}</a>
                      </li>
                      <li class="paginate_button page-item next" id="sorting-table_next">
                        <a
                          aria-controls="sorting-table"
                          data-dt-idx="3"
                          tabindex="0"
                          class="page-link"
                          @click="getBots({ page: page.next })"
                          >بعدی</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddFromExel @clicked="insert"></AddFromExel>
  </div>
</template>

<script>
import FakeUsersService from '../../../../services/fakeUsersService';

export default {
  name: 'fakeBots',
  components: {
    AddFromExel: () => import('./AddFakeFromExel'),
  },
  data() {
    return {
      users: [],
      page: {
        next: '',
        pre: '',
        current: '',
        total: '',
        count: '',
      },
    };
  },
  created() {
    this.getBots({ conditions: {} });
  },
  methods: {
    inserFromExel() {
      window.$('#AddFakeExel').modal('show');
    },
    async getBots({ conditions = {}, page = 1 }) {
      try {
        if (page == '' || parseInt(page) < 1) return;
        const service = new FakeUsersService();
        const res = await service.all({ page, condition: conditions });
        this.users = res.users;
        this.pageController(res);
      } catch (err) {
        console.log(err);
      }
    },
    async deleteBot(user) {
      if (!window.confirm(`حذف ربات «${user.username}»؟`)) return;
      try {
        const service = new FakeUsersService();
        await service.delete({ id: user._id });
        this.getBots({ conditions: {} });
        window.notif({ mssg: 'ربات حذف شد', isError: false });
      } catch (error) {
        console.log(error);
        window.notif({ mssg: 'مشکلی پیش آمده', isError: true });
      }
    },
    pageController(res) {
      this.page.count = res.count;
      this.page.current = res.currentPage;
      this.page.total = res.totalPages;
      if (this.page.current == this.page.total) {
        this.page.next = '';
      } else {
        this.page.next = parseInt(this.page.current) + 1;
      }
      if (this.page.current == 1) {
        this.page.pre = '';
      } else {
        this.page.pre = this.page.current - 1;
      }
    },
    async insert(file) {
      try {
        const data = new FormData();
        data.append('file', file);
        const service = new FakeUsersService();
        const res = await service.insert({ body: data });

        window.$('#AddFakeExel').modal('hide');
        if (res.inserted > 0) {
          window.notif({ isError: false, mssg: `تعداد ${res.inserted} ربات اضافه شد` });
          if (res.errCount > 0) {
            window.notif({ isError: true, mssg: `تعداد ${res.errCount} ردیف تکراری یا نامعتبر بود` });
          }
          if (res.skipped > 0) {
            window.notif({ isError: true, mssg: `تعداد ${res.skipped} ردیف بدون نام کاربری نادیده گرفته شد` });
          }
        } else if (res.errCount > 0) {
          window.notif({ isError: true, mssg: `هیچ ردیفی اضافه نشد. ${res.errCount} مورد تکراری یا نامعتبر` });
        } else {
          window.notif({ isError: true, mssg: 'فایل خالی است یا هیچ ردیف معتبری ندارد' });
        }
        this.getBots({ conditions: {} });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
